import React, { useState } from 'react';
import { useAppDispatch } from '../../../app/hooks';
import { fetchIntegrationData } from '../../../app/thunks/fetch-integration-data';
import { ReactComponent as IDAustriaLogo } from '../../../assets/images/IDAustriaLogo.svg';
import { useAppTranslation } from '../../../i18n';

export const IDAustriaButton = () => {
	const { t } = useAppTranslation();
	const dispatch = useAppDispatch();
	const [submitting, setSubmitting] = useState<boolean>(false);

	const onClickIDAustria = async () => {
		try {
			setSubmitting(true);
			await dispatch(fetchIntegrationData());
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div id="id-autria-auth" className="id-austria-auth-container">
			<div className="id-austria-auth-wrapper">
				<IDAustriaLogo height={50} />
				<button onClick={onClickIDAustria} className="id-austria-auth-button">
					{t('button.id-austria-login')}
				</button>
			</div>
		</div>
	);
};

export default IDAustriaButton;
